@import '../../../libs/rs-ui-shared/src/globals/glide';
@import '../../../../../../libs/rs-ui-shared/src/globals/typo';
@import '../../../global/styles/media-queries.scss';

:host {
    padding: 150px 0px 0px;

    @include on-tablet-small {
        padding: 0;
    }

    display: flex;
    flex-direction: column;

    --badge-animation-params: all 600ms cubic-bezier(0.19, 1, 0.22, 1);
    --all-other-animation-params: all 300ms ease;
    --csb-slider-arrow-color: #0076b2;
    --csb-slider-arrow-position: calc(40% - 200px);

    .headline {
        margin-bottom: 80px;
        color: #1d2021;
        font-family: var(--csb-font-family-roboto);
        font-size: 56px;
        font-weight: 300;
        font-stretch: condensed;
        line-height: 56px;
        text-transform: uppercase;
        letter-spacing: -0.02em;
        max-width: 1000px;
        align-self: center;

        text-align: center;

        @include on-tablet-small {
            text-align: left;
            font-size: 3.2rem;
            line-height: 3.2rem;
            margin-top: 100px;
            padding: 0 40px;
            margin-bottom: 48px;
        }
    }

    .single-slide {
        * {
            box-sizing: border-box;
        }

        .slide-container {
            transform: translateX(0);

            .card {
                display: flex;
                justify-content: center;

                @include on-tablet-big {
                    margin-bottom: 30px;
                }

                .inner-card {
                    background: #1d2021;
                    text-decoration: none;
                    border: 1px solid #1d2021;

                    .badges {
                        .badge {
                            color: white;
                            background: #0076b2;
                            text-align: center;

                            &:hover {
                                background: #00476b;
                            }
                        }
                    }

                    .body {
                        .location {
                            color: white;
                        }

                        .title,
                        .title:visited {
                            color: white;
                            text-decoration: solid;
                            text-decoration-color: #99c8e000; // make explicitly translucent for anim to work
                            transition: var(--all-other-animation-params);
                            -moz-transition: var(--all-other-animation-params);
                        }
                    }
                }

                .inner-card:hover {
                    border: 1px solid white;

                    .body {
                        .title {
                            color: #99c8e0;
                            text-decoration: none;
                        }
                    }
                }
            }

            .card {
                .inner-card {
                    display: flex;
                    flex-direction: column;
                    position: relative;
                    padding: 40px;
                    text-decoration: none;
                    justify-content: center;
                    align-items: center;
                    transition: var(--all-other-animation-params);

                    height: 608px !important;
                    max-width: 470px !important;
                    width: 470px !important;

                    @include on-tablet-small {
                        height: 456px !important;
                        max-width: 310px !important;
                        width: 310px !important;
                    }

                    .badges {
                        display: flex;
                        flex-wrap: wrap;
                        position: absolute;
                        justify-content: center;
                        overflow-y: auto;
                        top: 20px;
                        left: 50%;
                        transform: translateX(-50%);
                        gap: 8px;

                        @include on-tablet-small {
                            justify-content: flex-start;
                        }

                        .badge {
                            font-family: var(--csb-font-family-open-sans);
                            font-size: 12px;
                            font-weight: 400;
                            line-height: 16px;
                            padding: 4px 8px;
                            height: fit-content;
                            border-radius: 100px;
                            text-align: center;
                            transition: var(--badge-animation-params);
                        }
                    }

                    .body {
                        display: flex;
                        flex-direction: column;
                        gap: 8px;
                        width: 100%;

                        @include on-tablet-small {
                            top: 170px;
                        }

                        .location {
                            font-family: var(--csb-font-family-roboto);
                            font-size: 12px;
                            font-weight: 400;
                            line-height: 20px;
                            text-align: center;

                            @include on-tablet-small {
                                font-size: 16px;
                                line-height: 24px;
                            }
                        }

                        .title {
                            font-family: var(--csb-font-family-roboto);
                            font-size: 40px;
                            font-weight: 700;
                            font-stretch: condensed;
                            line-height: 44px;
                            text-transform: uppercase;
                            text-decoration: none;
                            hyphens: auto;
                            text-align: center;
                            cursor: pointer;

                            @include on-tablet-small {
                                font-size: 30px;
                                line-height: 32px;
                            }

                            transition: var(--all-other-animation-params);
                        }
                    }
                }
            }
        }
    }

    .carousel {
        display: flex;
        align-items: center;
        justify-content: center;

        .glide {
            .glide__track {
                .glide__slides {
                    .glide__slide {
                        .slide-container {
                            .card {
                                display: flex;
                                justify-content: center;

                                @include on-tablet-big {
                                    margin-bottom: 30px;
                                }

                                .inner-card {
                                    display: flex;
                                    flex-direction: column;
                                    position: relative;
                                    border: 1px solid #a8adb3;
                                    background: white;
                                    padding: 40px;
                                    text-decoration: none;
                                    justify-content: center;
                                    align-items: center;
                                    transition: var(--all-other-animation-params);
                                    -moz-transition: var(--all-other-animation-params);

                                    height: 608px !important;
                                    max-width: 470px !important;
                                    width: 470px !important;

                                    @include on-tablet-small {
                                        height: 456px !important;
                                        max-width: 310px !important;
                                        width: 310px !important;
                                    }

                                    .badges {
                                        display: flex;
                                        flex-wrap: wrap;
                                        position: absolute;
                                        justify-content: center;
                                        overflow-y: auto;
                                        top: 20px;
                                        left: 50%;
                                        transform: translateX(-50%);
                                        gap: 8px;

                                        @include on-tablet-small {
                                            justify-content: flex-start;
                                        }

                                        .badge {
                                            font-family: var(--csb-font-family-open-sans);
                                            font-size: 12px;
                                            font-weight: 400;
                                            line-height: 16px;
                                            padding: 4px 8px;
                                            height: fit-content;
                                            color: black;
                                            background: #e3f1f8;
                                            border-radius: 100px;
                                            text-align: center;
                                            transition: var(--badge-animation-params);
                                            -moz-transition: var(--badge-animation-params);
                                        }

                                        .badge:hover {
                                            background: #99c8e0;
                                        }
                                    }

                                    .body {
                                        display: flex;
                                        flex-direction: column;
                                        gap: 8px;
                                        width: 100%;

                                        @include on-tablet-small {
                                            top: 170px;
                                        }

                                        .location {
                                            font-family: var(--csb-font-family-roboto);
                                            font-size: 12px;
                                            font-weight: 400;
                                            line-height: 20px;
                                            text-align: center;
                                            color: black;

                                            @include on-tablet-small {
                                                font-size: 16px;
                                                line-height: 24px;
                                            }
                                        }

                                        .title {
                                            font-family: var(--csb-font-family-roboto);
                                            font-size: 40px;
                                            font-weight: 700;
                                            font-stretch: condensed;
                                            line-height: 44px;
                                            text-transform: uppercase;
                                            text-decoration: none;
                                            hyphens: auto;
                                            text-align: center;
                                            color: #1d2021;
                                            cursor: pointer;

                                            @include on-tablet-small {
                                                font-size: 32px;
                                                line-height: 32px;
                                            }

                                            transition: var(--all-other-animation-params);
                                            -moz-transition: var(--all-other-animation-params);
                                        }
                                    }
                                }

                                .inner-card:hover {
                                    .body {
                                        .title {
                                            color: #0076b2;
                                        }
                                    }
                                }
                            }
                        }

                        &.glide__slide--active {
                            .slide-container {
                                transform: translateX(0);

                                .card {
                                    .inner-card {
                                        background: #1d2021;
                                        text-decoration: none;
                                        border: 1px solid #1d2021;

                                        .badges {
                                            .badge {
                                                color: white;
                                                background: #0076b2;
                                                text-align: center;

                                                &:hover {
                                                    background: #00476b;
                                                }
                                            }
                                        }

                                        .body {
                                            .location {
                                                color: white;
                                            }

                                            .title,
                                            .title:visited {
                                                color: white;
                                                text-decoration: solid;
                                                text-decoration-color: #99c8e000; // make explicitly translucent for anim to work
                                                transition: var(--all-other-animation-params);
                                                -moz-transition: var(--all-other-animation-params);
                                            }
                                        }
                                    }

                                    .inner-card:hover {
                                        border: 1px solid white;

                                        .body {
                                            .title {
                                                color: #99c8e0;
                                                text-decoration: none;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            .glide__arrows {
                .glide__arrow {
                    padding: 0 !important;
                    height: 40px !important;
                    width: 40px !important;

                    opacity: 1;

                    &.hide-arrows {
                        opacity: 0;
                    }

                    @include on-tablet-small {
                        height: 24px !important;
                        width: 24px !important;
                    }

                    svg {
                        height: 40px !important;
                        width: 40px !important;
                        line-height: 0 !important;

                        @include on-tablet-small {
                            height: 24px !important;
                            width: 24px !important;
                        }

                        path {
                            stroke: #0076b2;
                            transition: var(--all-other-animation-params);
                        }
                    }

                    &.glide__arrow--left {
                        left: 50%;
                        transform: translateX(-340px);

                        //ORDER MATTERS
                        @include on-tablet-big {
                            transform: translateX(-228px) translateY(300px);
                        }

                        @include on-tablet-small {
                            transform: translateX(-155px) translateY(228px);
                        }
                    }

                    &.glide__arrow--right {
                        right: 50%;
                        transform: translateX(340px);

                        //ORDER MATTERS
                        @include on-tablet-big {
                            transform: translateX(228px) translateY(300px);
                        }

                        @include on-tablet-small {
                            transform: translateX(155px) translateY(228px);
                        }
                    }

                    &.glide__arrow--disabled {
                        opacity: 1 !important;
                    }
                }

                .glide__arrow:hover {
                    svg {
                        path {
                            stroke: black;
                        }
                    }
                }
            }
        }
    }

    .link {
        display: flex;
        justify-content: center;
        font-family: var(--csb-font-family-open-sans);
        font-size: 16px;
        line-height: 24px;
        text-align: center;
        padding: 40px 0px;

        a {
            &:first-child {
                padding: 8px 0px;
            }
        }

        arv-button-animated {
            --font-size: 16px;
            --back-button-height: auto;
            --back-button-padding-bottom: 6px;
        }
    }
}